//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import {
  SamplingCampaignRequestCountry,
  SamplingCampaignRequestLocale,
} from '@apis/campaign-requests/sampling/campaign-requests/samplingCampaignRequestsApiModel';

export const DEFAULT_LOCALE = 'en_US';

export interface CampaignRequestLocaleOption {
  label: string;
  value: SamplingCampaignRequestLocale;
  language: string;
  country: SamplingCampaignRequestCountry;
}

export const CAMPAIGN_REQUEST_LOCALES: CampaignRequestLocaleOption[] = [
  {
    label: 'English (US)',
    value: 'en_US',
    language: 'English',
    country: 'US',
  },
  {
    label: 'Czech (Czech Republic)',
    value: 'cs_CZ',
    language: 'Czech',
    country: 'CZ',
  },
  {
    label: 'Danish (Denmark)',
    value: 'da_DK',
    language: 'Danish',
    country: 'DK',
  },
  {
    label: 'Dutch (Belgium)',
    value: 'nl_BE',
    language: 'Dutch',
    country: 'BE',
  },
  {
    label: 'Dutch (Netherlands)',
    value: 'nl_NL',
    language: 'Dutch',
    country: 'NL',
  },
  {
    label: 'English (Australia)',
    value: 'en_AU',
    language: 'English',
    country: 'AU',
  },
  {
    label: 'English (Canada)',
    value: 'en_CA',
    language: 'English',
    country: 'CA',
  },
  {
    label: 'English (UK)',
    value: 'en_GB',
    language: 'English',
    country: 'GB',
  },
  {
    label: 'Finnish (Finland)',
    value: 'fi_FI',
    language: 'Finnish',
    country: 'FI',
  },
  {
    label: 'French (Belgium)',
    value: 'fr_BE',
    language: 'French',
    country: 'BE',
  },
  {
    label: 'French (Canada)',
    value: 'fr_CA',
    language: 'French',
    country: 'CA',
  },
  {
    label: 'French (France)',
    value: 'fr_FR',
    language: 'French',
    country: 'FR',
  },
  {
    label: 'French (Luxembourg)',
    value: 'fr_LU',
    language: 'French',
    country: 'LU',
  },
  {
    label: 'French (Switzerland)',
    value: 'fr_CH',
    language: 'French',
    country: 'CH',
  },
  {
    label: 'German (Austria)',
    value: 'de_AT',
    language: 'German',
    country: 'AT',
  },
  {
    label: 'German (Belgium)',
    value: 'de_BE',
    language: 'German',
    country: 'BE',
  },
  {
    label: 'German (Germany)',
    value: 'de_DE',
    language: 'German',
    country: 'DE',
  },
  {
    label: 'German (Luxembourg)',
    value: 'de_LU',
    language: 'German',
    country: 'LU',
  },
  {
    label: 'German (Switzerland)',
    value: 'de_CH',
    language: 'German',
    country: 'CH',
  },
  {
    label: 'Hungarian (Hungary)',
    value: 'hu_HU',
    language: 'Hungarian',
    country: 'HU',
  },
  {
    label: 'Italian (Italy)',
    value: 'it_IT',
    language: 'Italian',
    country: 'IT',
  },
  {
    label: 'Norwegian (Norway)',
    value: 'no_NO',
    language: 'Norwegian',
    country: 'NO',
  },
  {
    label: 'Polish (Poland)',
    value: 'pl_PL',
    language: 'Polish',
    country: 'PL',
  },
  {
    label: 'Portuguese (Portugal)',
    value: 'pt_PT',
    language: 'Portuguese',
    country: 'PT',
  },
  {
    label: 'Spanish (Spain)',
    value: 'es_ES',
    language: 'Spanish',
    country: 'ES',
  },
  {
    label: 'Swedish (Sweden)',
    value: 'sv_SE',
    language: 'Swedish',
    country: 'SE',
  },
];
